import { animate, cubicBezier, stagger, frame } from "motion";

export class Feature {
    constructor(element) {
        this.element = element;
        this.positionX = 0;
        this.positionY = 0;
        this.modal = null;
        this.bezier = cubicBezier(0.23, 1, 0.32, 1);

        this.init();
    }

    init() {
        this.element.addEventListener("click", (event) => {
            event.preventDefault();

            const feature_modal_id = this.element.getAttribute("data-modal-id");
            this.renderModal(feature_modal_id);

            this.animateIn(event);
            this.handleModalClose();
        });
    }

    handleModalClose() {
        this.modal
            .querySelector(".js-close-features")
            .addEventListener("click", () => {
                this.animateOut().then(() => {
                    const featuresModals = [...document.querySelectorAll('.features-modal')];
                    featuresModals.forEach(modal => {
                        modal.remove();
                    });
                });
            });
    }

    appendTemplateToBody(clone) {
        document.body.appendChild(clone);
        const modal = document.querySelector(".features-modal");
        return modal ?? undefined;
    }

    renderModal(id) {
        const modalTemplate = document.getElementById(id);
        if (!modalTemplate) {
            console.error(`Modal template with id "${id}" not found.`);
            return;
        }

        const modalElement = modalTemplate.content.cloneNode(true);
        const modal = this.appendTemplateToBody(modalElement);
        modal.classList.add("modal-active");

        this.modal = modal;
    }


    /*--------------------------------------------
        Animations
    ----------------------------------------------*/

    setMousePostion(event) {
        this.positionX = event.clientX;
        this.positionY = event.clientY;
    }

    animateIn(event) {
        const animatePosition = this.getAnimatePosition(event);

        animate(
            this.modal,
            {
                x: [animatePosition['x'], 0],
                y: [animatePosition['y'], 0],
                scale: [0, 1],
            },
            { ease: this.bezier, duration: 0.3 }
        ).then(() => {
            this.animateContentIn();

            const mediaElement = this.modal.querySelector(".js-features-modal__image");
            const maxTilt = 2;
            this.addElementTilt(mediaElement, maxTilt);
        });
    }

    animateOut() {
        const animatePosition = this.getAnimatePosition();

        return animate(
            this.modal,
            {
                x: [0, animatePosition['x']],
                y: [0, animatePosition['y']],
                scale: [1, 0],
            },
            { ease: this.bezier, duration: 0.3 }
        );
    }

    getAnimatePosition(event) {
        if (event !== undefined) {
            this.setMousePostion(event)
        }

        // get the modal width and height
        const modalWidth = this.modal.offsetWidth;
        const modalHeight = this.modal.offsetHeight;

        // calculate the position of the modal
        const x = this.positionX - modalWidth / 2;
        const y = this.positionY - modalHeight / 2;

        return {
            x: x,
            y: y,
        };
    }

    animateContentIn() {
        // Get the media element
        const mediaElement = this.modal.querySelector(".features-modal__media");
        const mediaImage = mediaElement.querySelector("img");
        const mediaElements = [mediaElement, mediaImage];

        mediaElements.forEach((element, index) => {
            animate(element,
                {
                    opacity: [0, 1],
                    x: [-100, 0],
                    y: [-100, 0]
                },
                {
                    ease: this.bezier,
                    duration: 0.5,
                    delay: stagger(0.2 * index)
                }
            )
        });

        const contentWrap = this.modal.querySelector(".js-features-modal__wrap");
        const children = [...contentWrap.childNodes].filter((child) => child.nodeType === 1);
        children.forEach((child, index) => {
            animate(child,
                {
                    opacity: [0.5, 1],
                    x: [100, 0],
                    y: [100, 0]
                },
                {
                    ease: this.bezier,
                    duration: 0.5,
                    delay: stagger(0.2 * index)
                }
            );
        });
    }

    addElementTilt(element, maxTilt = 5) {
        if (!element) {
            return;
        }

        const tilt = {
            z: 0,
            rotateX: 0,
            rotateY: 0,
        }

        // Calculate tilt based on pointer position
        function calculateTilt(event) {
            const rect = element.getBoundingClientRect()
            tilt.z = -10
            const x = event.clientX - rect.left
            const y = event.clientY - rect.top

            // Convert coordinates to percentages
            const xPercent = x / rect.width
            const yPercent = y / rect.height

            tilt.rotateX = maxTilt * (0.5 - yPercent)
            tilt.rotateY = maxTilt * (xPercent - 0.5)
        }

        function animateToTilt() {
            animate(element, {
                transformPerspective: 500,
                rotateX: tilt.rotateX,
                rotateY: tilt.rotateY,
                z: tilt.z,
            })
        }

        function updateTilt(e) {
            calculateTilt(e)
            frame.postRender(animateToTilt)
        }

        element.addEventListener("pointerenter", updateTilt)
        element.addEventListener("pointermove", updateTilt)
        element.addEventListener("pointerleave", () => {
            tilt.z = 0
            tilt.rotateX = 0
            tilt.rotateY = 0
            frame.postRender(animateToTilt)
        })

    }
}